import { z } from "zod";

const optionalStringParam = z
  .union([z.string(), z.number(), z.boolean()])
  .transform(String)
  .optional()
  .catch(undefined);

export const topicsSearchSchema = z.object({
  page: z.number().int().positive().optional().catch(undefined),
  order: z
    .record(z.string(), z.enum(["asc", "desc"]))
    .optional()
    .catch(undefined),
  query: optionalStringParam,
  admin_only: optionalStringParam,
  created_by: optionalStringParam,
  spaces: optionalStringParam,
});
